import api from "../api";

/* ------------------ Address ------------------ */

export const getUserAddresses = () => {
  return api.get("/accounts/me/addresses/");
};

export const setCheckoutAddress = async (addressId) => {
  const res = await api.post("/operation/checkout/select-address/", {
    address_id: addressId,
  });
  return res.data;
};

/* ------------------ Checkout ------------------ */

export const getCheckout = async () => {
  const res = await api.get("/operation/checkout/");
  return res.data;
};

export const selectShippingMethod = async ({ shipmentId, optionId }) => {
  const res = await api.post("/operation/checkout/method-selection/", {
    deliverygroup_id: shipmentId,
    option_id: optionId,
  });
  return res.data;
};


export const getCheckoutReview = async () => {
  const res = await api.get("/operation/checkout/checkout-review/");
  return res;
};

export const applyCouponCheckout = async (code) => {
  const res = await api.post("/operation/coupons/apply-coupon/", { code });
  return res;
}

export const startPayment = async (couponCode) => {
  const res = await api.post("operation/payments/start/", {
      coupon_code: couponCode
    });
  return res;
}



